export default __webpack_public_path__ + "media/zurb/img/bryan/thumbs/6-c680c5cc0b157caf0f8af6f9e70236d7.png";